import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { GateExcludeGateItemMaintenanceDto } from './GateExcludeGateItemMaintenanceDto';
import { GateExcludeGateListMaintenanceDto } from './GateExcludeGateListMaintenanceDto';

@Injectable()
export class GateExcludeGateSubMaintenanceController extends BaseSubMaintenanceController<GateExcludeGateListMaintenanceDto, GateExcludeGateItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "gate/exclude");
    }

    public getResourceRoot(): string {
        return "GATE.EXCLUDE.GATE";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/dataandparameters/gate/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}